import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from './Icons';
interface QuoteFormProps {
  lang: 'en' | 'es';
}
export function QuoteForm({
  lang
}: QuoteFormProps) {
  const [formLang, setFormLang] = useState<'en' | 'es'>(lang);
  const [condition, setCondition] = useState('new');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const content = {
    en: {
      title: 'Get Your Free Quote',
      subtitle: "I'll contact you the same day",
      name: 'Full Name',
      phone: 'Phone',
      email: 'Email',
      prefLang: 'Preferred Language',
      brand: 'Brand Interest',
      condition: 'New or Pre-Owned?',
      budget: 'Budget',
      message: 'Message (Optional)',
      submit: 'Send My Request',
      sending: 'Sending...',
      footer: 'Simon personally responds to every inquiry within hours.',
      successTitle: 'Request Sent!',
      successMsg: 'Simon will contact you within hours. Thank you!',
      errorMsg: 'Something went wrong. Please try again.',
      sendAnother: 'Send Another Request',
      brands: ['Subaru', 'Toyota', 'Honda', 'Ford', 'Chevrolet', 'Nissan', 'Hyundai', 'Kia', 'BMW', 'Mercedes-Benz', 'Mazda', 'Jeep', 'Other Brand'],
      conditions: [{
        id: 'new',
        label: 'New'
      }, {
        id: 'used',
        label: 'Pre-Owned'
      }, {
        id: 'both',
        label: 'Open to Both'
      }],
      budgets: ['Under $20K', '$20K–$35K', '$35K–$50K', '$50K+', 'Not sure'],
      select: 'Select...'
    },
    es: {
      title: 'Cotización Gratis',
      subtitle: 'Te contacto el mismo día',
      name: 'Nombre completo',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      prefLang: 'Idioma preferido',
      brand: 'Marca de Interés',
      condition: '¿Nuevo o Usado?',
      budget: 'Presupuesto',
      message: 'Mensaje (Opcional)',
      submit: 'Enviar Mi Solicitud',
      sending: 'Enviando...',
      footer: 'Simon responde personalmente a cada solicitud en pocas horas.',
      successTitle: '¡Solicitud Enviada!',
      successMsg: 'Simon te contactará en pocas horas. ¡Gracias!',
      errorMsg: 'Algo salió mal. Inténtalo de nuevo.',
      sendAnother: 'Enviar Otra Solicitud',
      brands: ['Subaru', 'Toyota', 'Honda', 'Ford', 'Chevrolet', 'Nissan', 'Hyundai', 'Kia', 'BMW', 'Mercedes-Benz', 'Mazda', 'Jeep', 'Otra Marca'],
      conditions: [{
        id: 'new',
        label: 'Nuevo'
      }, {
        id: 'used',
        label: 'Usado'
      }, {
        id: 'both',
        label: 'Ambos'
      }],
      budgets: ['Menos de $20K', '$20K–$35K', '$35K–$50K', '$50K+', 'No sé'],
      select: 'Selecciona...'
    }
  };
  const t = content[lang];
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError('');
    const formData = new FormData(event.currentTarget);
    formData.append('condition', condition);
    formData.append('preferred_language', formLang === 'en' ? 'English' : 'Español');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });
      const data: {
        success?: boolean;
      } = await response.json();
      if (data.success) {
        setIsSuccess(true);
      } else {
        setError(t.errorMsg);
      }
    } catch {
      setError(t.errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSuccess) {
    return <section id="quote-form" className="border-y border-border bg-formBg px-6 py-24" data-id="element-102">
        <div className="mx-auto max-w-3xl" data-id="element-103">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="rounded-xl border border-border bg-card p-10 text-center md:p-16" data-id="element-104">
            <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10" data-id="element-105">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#0057FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-106">
                <path d="M20 6 9 17l-5-5" data-id="element-107" />
              </svg>
            </div>
            <h2 className="mb-4 text-3xl font-bold md:text-4xl" data-id="element-108">
              {t.successTitle}
            </h2>
            <p className="mb-10 text-lg text-[#aaaaaa]" data-id="element-109">{t.successMsg}</p>
            <button type="button" onClick={() => setIsSuccess(false)} className="rounded-full border border-white/20 px-8 py-3 font-medium text-white transition-colors hover:border-white/50" data-id="element-110">
              {t.sendAnother}
            </button>
          </motion.div>
        </div>
      </section>;
  }
  return <section id="quote-form" className="border-y border-border bg-formBg px-6 py-24" data-id="element-111">
      <div className="mx-auto max-w-3xl" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-113">
          <h2 className="mb-4 text-3xl font-bold md:text-4xl" data-id="element-114">{t.title}</h2>
          <p className="text-lg text-[#aaaaaa]" data-id="element-115">{t.subtitle}</p>
        </motion.div>

        <motion.form initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} onSubmit={handleSubmit} className="space-y-6 rounded-xl border border-border bg-card p-6 md:p-10" data-id="element-116">
          <input type="hidden" name="access_key" value="2840eb19-a382-4722-a25c-1778cd0c698d" data-id="element-117" />
          <input type="hidden" name="subject" value="New Quote Request — SimonPro.vip" data-id="element-118" />
          <input type="hidden" name="from_name" value="Simon Pro Website" data-id="element-119" />

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-120">
            <Field label={t.name} data-id="element-121">
              <input type="text" name="name" required className="input-field" data-id="element-122" />
            </Field>
            <Field label={t.phone} data-id="element-123">
              <input type="tel" name="phone" required className="input-field" data-id="element-124" />
            </Field>
          </div>

          <Field label={t.email} data-id="element-125">
            <input type="email" name="email" required className="input-field" data-id="element-126" />
          </Field>

          <div data-id="element-127">
            <p className="mb-2 text-sm font-medium text-white/80" data-id="element-128">
              {t.prefLang}
            </p>
            <div className="flex rounded-lg border border-border bg-inputBg p-1" data-id="element-129">
              <button type="button" onClick={() => setFormLang('en')} className={`flex-1 rounded-md py-2 text-sm font-medium transition-colors ${formLang === 'en' ? 'border border-border bg-card text-white' : 'text-[#aaaaaa] hover:text-white'}`} data-id="element-130">
                English
              </button>
              <button type="button" onClick={() => setFormLang('es')} className={`flex-1 rounded-md py-2 text-sm font-medium transition-colors ${formLang === 'es' ? 'border border-border bg-card text-white' : 'text-[#aaaaaa] hover:text-white'}`} data-id="element-131">
                Español
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-132">
            <Field label={t.brand} data-id="element-133">
              <select name="brand_interest" defaultValue="" className="input-field" data-id="element-134">
                <option value="" disabled data-id="element-135">
                  {t.select}
                </option>
                {t.brands.map(brand => <option key={brand} value={brand} data-id="element-136">
                    {brand}
                  </option>)}
              </select>
            </Field>
            <Field label={t.budget} data-id="element-137">
              <select name="budget" defaultValue="" className="input-field" data-id="element-138">
                <option value="" disabled data-id="element-139">
                  {t.select}
                </option>
                {t.budgets.map(budget => <option key={budget} value={budget} data-id="element-140">
                    {budget}
                  </option>)}
              </select>
            </Field>
          </div>

          <div data-id="element-141">
            <p className="mb-3 text-sm font-medium text-white/80" data-id="element-142">
              {t.condition}
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-143">
              {t.conditions.map(item => <button key={item.id} type="button" onClick={() => setCondition(item.id)} className={`rounded-full border px-5 py-2.5 text-sm font-medium transition-colors ${condition === item.id ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-inputBg text-[#aaaaaa] hover:border-white/30 hover:text-white'}`} data-id="element-144">
                  {item.label}
                </button>)}
            </div>
          </div>

          <Field label={t.message} data-id="element-145">
            <textarea name="message" rows={3} className="input-field resize-none" data-id="element-146" />
          </Field>

          {error && <p role="alert" className="text-center text-sm text-red-400" data-id="element-147">
              {error}
            </p>}

          <button type="submit" disabled={isSubmitting} className="mt-8 flex h-[52px] w-full items-center justify-center gap-2 rounded-lg bg-primary font-medium text-white transition-colors hover:bg-blue-600 disabled:cursor-not-allowed disabled:opacity-60" data-id="element-148">
            {isSubmitting ? t.sending : t.submit}
            {!isSubmitting && <ArrowRight size={20} data-id="element-149" />}
          </button>

          <p className="text-center text-sm text-[#666666]" data-id="element-150">{t.footer}</p>
        </motion.form>
      </div>
    </section>;
}
function Field({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <label className="block space-y-2 text-sm font-medium text-white/80" data-id="element-151">
      <span data-id="element-152">{label}</span>
      {children}
    </label>;
}